// Hooks (@tanstack/react-query) imports
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { Invoice, InvoiceRegistration } from "./types";
import { ApiErrorResponse } from "apisauce";
import { fetchingModelDefaults } from "../tickets/types";

// Hooks & actions imports
import { useAppSelector } from "../../app/hook";

interface paramsType {
  invoice: InvoiceRegistration;
  notificationID: string | number;
}

export function useCreateInvoiceMutation(
  onSuccessMutation?: (data: Invoice, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  const queryClient = useQueryClient();
  const currentUser = useAppSelector((state) => state.auth);

  async function createInvoice(params: paramsType): Promise<Invoice> {
    const response = await api.post<Invoice>(
      "invoices/invoices",
      params.invoice
    );

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: createInvoice,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([
        "TicketsInfinite",
        ...Object.values({
          ...fetchingModelDefaults,
          storeID:
            !!currentUser.user?.companyID && currentUser.user?.companyID !== -1
              ? currentUser.user.companyID
              : 0,
        }),
      ]);
      onSuccessMutation?.(data, variables);
    },
    onError: onErrorMutation,
  });
}
